import { ILocalization, ILocalizationToken } from '../../../application/language/ILocalization';
import { IContainer } from '../../../common/container/IContainer';
import { mergeDeep } from '../../../common/utils/mergeDeep';
import en from './en/DataManagerTranslation.json';
import ru from './ru/DataManagerTranslation.json';

const getTranslations = () => {
  return {
    en: {
      translation: en,
    },
    ru: {
      translation: ru,
    },
  };
};

export const addDataManagerTranslations = async (container: IContainer) => {
  const lang = container.getByToken<ILocalization, any>(ILocalizationToken);
  const riskManagerLangs = getTranslations();
  lang.i18n.store.data = mergeDeep(lang.i18n.store.data, riskManagerLangs);

  return container;
};
